import { useModal } from "../../../../Shared/components/Modal";
import { mealSizeModuleSliderSettings } from "../../../../Shared/utils/sliderSettings";
import { useOrderFlow } from "../../../OrderFlowProvider/OrderFlowContext";
import { ModuleNames } from "../../../OrderFlowProvider/OrderFlowTypes";
import { curriedHandleMealSizeChange, getMealSizesToRender } from "./mealSizeUtils";
/**
 * useMealSize - Handles set default meal size, handle meal size change, and defines meal sizes to render
 * @param sequenceNumber: used to identify specific module when more than one of the same kind is used in the flow builder
 * @returns handle meal size function and meal sizes to render
 */
export const useMealSize = (sequenceNumber) => {
    var _a;
    const { store, dispatch } = useOrderFlow();
    const { showModal } = useModal();
    const moduleConfig = (_a = store.model.Flow.FlowModules.find((mod) => mod.ModuleName === ModuleNames.MEAL_SIZE && mod.Sequence === sequenceNumber && mod.Page === store.cart.currentPage)) === null || _a === void 0 ? void 0 : _a.ModuleConfig;
    const { IsGridLayout, MealSizesToIgnore, ClearMealsOnMealSizeChanged, MealSizeDisplayMode, CardDescriptionLines, ShowImage, CenterCards, ShowDescription, } = moduleConfig;
    const { MealSizes } = store.model;
    const { mealSize: storeCartMealSize, template, meals: storeCartMeals } = store.cart;
    const mealSizesToRender = getMealSizesToRender(MealSizes, MealSizesToIgnore);
    const mealSizeCardLayoutSettings = {
        isGridLayout: IsGridLayout,
        sliderSettings: mealSizeModuleSliderSettings(moduleConfig.ScreenLG, moduleConfig.ScreenMD, moduleConfig.ScreenSM, moduleConfig.ScreenXS),
        cardsPerRowXS: moduleConfig.ScreenXS,
        cardsPerRowSM: moduleConfig.ScreenSM,
        cardsPerRowMD: moduleConfig.ScreenMD,
        cardsPerRowLG: moduleConfig.ScreenLG,
        gridSpacing: moduleConfig.GridSpacing,
        CenterCards,
    };
    return {
        handleMealSizeChange: curriedHandleMealSizeChange(mealSizesToRender, storeCartMealSize, template, storeCartMeals, ClearMealsOnMealSizeChanged, showModal, dispatch),
        mealSizesToRender,
        mealSizeCardLayoutSettings,
        MealSizes,
        storeCartMealSize,
        MealSizeDisplayMode,
        CardDescriptionLines,
        showDescription: ShowDescription,
        ShowImage,
        CenterCards,
    };
};
